var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",attrs:{"id":"TV_INPUT","name":"TV_INPUT","data-vcode":"Source","disabled":"","aria-label":`${_vm.$t('tvInput')}`}},[_c('img',{attrs:{"src":"/images/icons/tvInput.svg","alt":""}}),_c('label',{attrs:{"aria-hidden":"true"}},[_vm._v(_vm._s(_vm.$t('tvInput')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }